import { useState } from "react";
import { addMemory } from "../api/members";
import { logEvent } from "../utils/logEvent";

export default function AddMemoryForm({ memberId, onAdded }) {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [date, setDate] = useState("");

  async function submit() {
    await addMemory(memberId, { title, text, date });

    logEvent("add_memory_executed", {
      memberId: memberId,
      title: title,
      text: text,
      date: date
    });

    setTitle("");
    setText("");
    setDate("");
    onAdded();
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <h3>Add a memory of your loved one...</h3>
      <input
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      /><br/><br/>

      <textarea
        placeholder="Text"
        value={text}
        onChange={(e) => setText(e.target.value)}
      /><br/><br/>

      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
      /><br/><br/>

      <button className="memory-submit-btn" onClick={submit}>Add Memory</button>
    </div>
  );
}
